import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/collapseInfoSection/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showCollapseInfoSectionSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showCollapseInfoSectionSelector };
